// Defers secondary CTAs (newsletter popup, AI Safari Planner) until a visitor has
// shown safari interest — per client UX request: don't overwhelm new visitors with
// CTAs before they've explored. "Interest" = browsing a Safari page or viewing a
// product in detail. Persisted per-session so it survives navigation.
const KEY = 'jth_safari_interest';

// Routes that count as browsing safaris / viewing a product in detail.
const INTEREST_RE = /^\/safaris(\/|$)|^\/destinations\/[^/]+\/[^/]+|^\/excursions\/[^/]+/i;

export function pathShowsInterest(pathname = '') {
  return INTEREST_RE.test(pathname);
}

export function markInterest() {
  try { sessionStorage.setItem(KEY, '1'); } catch (_) { /* ignore */ }
}

export function hasInterest() {
  try { return sessionStorage.getItem(KEY) === '1'; } catch (_) { return false; }
}
